import { gql } from 'graphql-request';

const updateStoreCourierSettings = gql`
  mutation(
    $autoAssignMechanism: AutoAssignMechanismFromEnum
    $courierId: Int!
    $driverMaxCapacity: Int
    $storeId: Int!
  ) {
    updateStoreCourierSettings(
      autoAssignMechanism: $autoAssignMechanism
      courierId: $courierId
      driverMaxCapacity: $driverMaxCapacity
      storeId: $storeId
    ) {
      storeCourierSettings {
        id
        driverMaxCapacity
        autoAssignMechanism
      }
    }
  }
`;

export default updateStoreCourierSettings;
